import { useMutation } from '@tanstack/react-query';
import { toast } from 'sonner';
import { useTranslation } from 'react-i18next';
import { useAuthContext } from '@/contexts/AuthContext';
import { updateConsumer, type ConsumerUpdate } from '@/services/consumers.service';
import { sanitizeSupabaseError } from '@/lib/errorHandler';

/**
 * Expõe o perfil do consumer autenticado (a partir do AuthContext) e a mutation
 * para o atualizar. Após sucesso, faz refreshConsumer para refletir sem reload.
 */
export function useConsumer() {
  const { consumer, user, refreshConsumer } = useAuthContext();
  const { t } = useTranslation();

  const mutation = useMutation({
    mutationFn: async (patch: ConsumerUpdate) => {
      if (!user) throw new Error('not_authenticated');
      return updateConsumer(user.id, patch);
    },
    onSuccess: async () => {
      await refreshConsumer();
      toast.success(t('consumer.profile.saved'));
    },
    onError: (error) => {
      toast.error(sanitizeSupabaseError(error));
    },
  });

  return { consumer, updateConsumer: mutation.mutate, isSaving: mutation.isPending };
}
